__turbopack_context__.v({
  "endIcon": "Buttons-module-scss-module__6gtZ3a__endIcon",
  "primary": "Buttons-module-scss-module__6gtZ3a__primary",
  "secondary": "Buttons-module-scss-module__6gtZ3a__secondary",
  "startIcon": "Buttons-module-scss-module__6gtZ3a__startIcon",
});
